import { useQuoteModal } from '../../../context/QuoteModalContext';

export default function GalleryCTA() {
  const { openModal } = useQuoteModal();
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/img/b22ab00bfcad.webp"
          alt="Pop Pro Tents events"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-teal-600/80"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-6">
          Love What You See?<br />Let's Create Something Amazing
        </h2>
        <p className="text-white/90 text-lg mb-10 max-w-xl mx-auto">
          Whether it's a dream wedding, a festival, or a corporate event, our stretch tents transform any space into an extraordinary experience.
        </p>
        <button
          type="button"
          onClick={openModal}
          className="inline-block bg-white text-teal-600 hover:bg-teal-50 px-10 py-4 rounded-lg text-base font-bold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Inquire Now
        </button>
      </div>
    </section>
  );
}
